import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BranchesService } from './logic/branches.service';
import { BranchesLogicService } from './logic/branches/branches-logic.service';
import { BranchesDaoService } from './dao/branches-dao.service';
import { BranchesDbDaoService } from './dao/branches-dao/branches-db-dao.service';
import { BranchDbTableDefinition } from './dao/branches-dao/branches-db-table-definition';
import { LocalBranchDbTableDefinition } from './dao/branches-dao/local-branches-db-table-definition';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: BranchesService, useClass: BranchesLogicService },
    { provide: BranchesDaoService, useClass: BranchesDbDaoService },
    { provide: BranchDbTableDefinition },
    { provide: LocalBranchDbTableDefinition },
  ]
})
export class BranchesModule {}
